import { FC, FormHTMLAttributes, FormEvent } from "react";

import styles from "./Form.module.scss";

type Props = FormHTMLAttributes<HTMLFormElement> & {
  onSubmit: () => void;
  disabled?: boolean;
  encType?: string;
};

export const Form: FC<Props> = ({
  onSubmit: submitHandler,
  children,
  disabled = false,
  encType = "application/x-www-form-urlencoded",
  ...props
}) => {
  const onSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    event.stopPropagation();

    if (disabled) return;

    submitHandler();
  };

  return (
    <form onSubmit={onSubmit} encType={encType} {...props}>
      {children}
      <button className={styles.submit} type="submit" />
    </form>
  );
};
